<template>
    <div class="page_body">
        <div class="data_main">
<!-- 
            <div class="data_group mt18">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="$router.push('/user/add')">添加用户</el-button>
            </div> -->

            <div class="data_search" v-if="power.indexOf('1')>=0">
              <el-form ref="listQuery" :inline="true" :model="listQuery" size="small" label-width="72px">
                  <el-form-item label="用户昵称：" prop="nickname">
                      <el-input v-model="listQuery.nickname" placeholder="请输入用户昵称" @keyup.enter.native="toSearchList"></el-input>
                  </el-form-item>
                  <el-form-item label="用户账号：" prop="phone">
                      <el-input v-model="listQuery.phone" placeholder="请输入用户账号" @keyup.enter.native="toSearchList"></el-input>
                  </el-form-item>
                  <el-form-item class="last">
                      <el-button type="primary" :loading="isSearchLoading" @click="toSearchList()">查 询</el-button>
                      <el-button @click="$refs['listQuery'].resetFields()">重 置</el-button>
                  </el-form-item>
              </el-form>
          </div>
            <div class="data_table mt18">
                <el-table :data="listData" style="width: 100%" v-loading="isRequestLoading">
                    <el-table-column type="index" label="序号" width="80px" align="center"></el-table-column>
                    <el-table-column prop="phone" label="账号" min-width="100px" align="center"></el-table-column>
                    <el-table-column prop="nickname" label="昵称" min-width="100px" align="center"></el-table-column>
                    <el-table-column label="头像" min-width="100px" align="center">
                      <template slot-scope="scope">
                        <img :src="imageURL+scope.row.avatar" v-if="scope.row.avatar" class="picImg">
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="address" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="$router.push({path: '/user/edit', query: {account:scope.row.account, id: scope.row.id, nickname: scope.row.nickname, avatar: scope.row.avatar}})">编辑</el-button>
                            <el-button type="text" @click="delUser(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>

          <pagination :size="listQuery.size" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
        </div>
    </div>
</template>

<script>
import pagination from '../../components/pagination'
import {mapState} from "vuex";
import {getUser} from "@/api";
import {splitTTimes} from '../../utils/dateFormat'
export default {
  name: "userRole",
  data () {
    return {
      imageURL: window.config.imageURL,
      splitTTimes,
      listQuery: {
        nickname:'',
        phone:'',
        page: 1,
        size: 10
      },
      pages: {
        total: 0,
        pages: 0
      },
      isSearchLoading: false,
      isRequestLoading: false,
      listData: [],
      power:null
    }
  },
  computed: {
    ...mapState({
      listKeepAlive: state => state.app.listKeepAlive,
    })
  },
  activated () {
    this.getList(this.listQuery)
  },
  created(){
    this.power = JSON.parse(localStorage.getItem('userRole')).power[5]
  },
  beforeRouteLeave (to, from, next) {
    if (to.name=='userListEdit' || to.name=='userListAdd') {
      sessionStorage.setItem("listQuery",JSON.stringify(this.listQuery))
      sessionStorage.setItem("goName",to.name)
    }else{
      sessionStorage.removeItem('listQuery')
      sessionStorage.removeItem('goName')
    }
    next()
  },
  methods: {
    // delUser (id) {
    //   this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     closeOnClickModal: false,
    //     type: 'warning'
    //   }).then(() => {
    //     delUser(id).then(res => {
    //       if (res.code === 0) {
    //         this.$message({
    //           message: '用户删除成功',
    //           type: 'success',
    //           showClose: true,
    //         });
    //         this.getList()
    //       }
    //     })
    //   }).catch(() => {});
    // },
    getList () {
      this.isRequestLoading = true
      getUser(this.listQuery).then(res => {
        this.isRequestLoading = false
        this.isSearchLoading = false
        if (res.code === 0) {
          this.isShow = true
          this.listData = res.data.records
          this.pages.total = res.data.total
          this.pages.pages = res.data.pages
        }
      }).catch(() => {
        this.isRequestLoading = false
        this.isSearchLoading = false
      })
    },
    toSearchList () {
      this.listQuery.page = 1;
      this.isSearchLoading = true;
      this.getList()
    },
    pageChange (e) {
      this.listQuery.page = e.current
      this.listQuery.size = e.size
      this.getList()
    },
  },
  components: {
    pagination
  }
}
</script>
<style lang="scss" scoped>
.picImg{
  max-width: 120px;
}
</style>
